export default "__VITE_ASSET__DmoiSaBc__"